import { fillString } from '@local_modules/generic/string-template.js'
import { AutoAgGrid, generateString, setPageAsFullHeight } from '@local_modules/flokit'
import '@local_modules/flokit/styles.css'
import { setElementHtml } from '../../../../helpers/generic-js/dom.js'

import htmlTemplateIndex from './index.html'

import { checkPageRestriction } from '../../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../../helpers/restrictions/apply-html-restrictions.js'

const ALLOWED_OBJECT_NAMES = [
  'chartOfAccounts',
  'contacts',
  'journalLines',
  'journals',
  'sources'
]

/**
 *
 * @param {Object} params
 * @param {String} params.containerElementId
 * @param {Object} params.browserAppUser
 * @param {Object} params.browserAppEntity
 * @param {Object} params.accountingOrganisationId
 * @param {String} params.objectName
 *
 * @returns
 */
export async function showAdminEntityDuplicatesForObject (params) {
  console.log('showAdminEntityDuplicatesForObject')

  const { containerElementId, browserAppUser, browserAppEntity, accountingOrganisationId, objectName } = params

  if (!checkPageRestriction({ browserAppUser, allowNoAccount: true })) return

  if (!ALLOWED_OBJECT_NAMES.includes(objectName)) {
    console.log('objectName not allowed', objectName)
    return
  }

  // Prepare the html
  let htmlIndex = htmlTemplateIndex

  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppUser })
  const elementId = 'i' + generateString()
  htmlIndex = fillString(htmlIndex, {
    elementId,
    accountingOrganisationId,
    entityName: browserAppEntity?.data?.appEntity?.name,
    objectName
  })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  setPageAsFullHeight(true, { containerSelector: '#app-content' })

  // Set page title
  document.title = ['Entity duplicate journals'].join(' ')

  let apiUrl = '/api/data-review/xero_duplicates/:accountingOrganisationId/:objectName'
  apiUrl = fillString(apiUrl, { accountingOrganisationId, objectName })

  const autoAgGrid = new AutoAgGrid({
    containerSelector: '#entityGrid',
    sourceUrl: apiUrl
  })
  console.log('autoAgGrid', autoAgGrid)
  return autoAgGrid
}
